import { Tabs } from 'antd';
import './TabImage.scss';
const { TabPane } = Tabs;
export default function (props) {
    const [active, setActive] = useState('0');
    const handleClick = idx => {
        setActive(idx + '');
    };
    return (
        <div className="tab-image-wrap">
            <div className="btn-list">
                {props.btnList.map((v, index) => (
                    <div
                        className={`tab-btn ${
                            +active === index ? 'active' : ''
                        }`}
                        key={index}
                        onClick={() => handleClick(index)}>
                        {v}
                    </div>
                ))}
            </div>
            <Tabs defaultActiveKey={0} activeKey={active}>
                {props.btnList.map((v, index) => {
                    return (
                        <TabPane tab="Tab 1" key={index}>
                            {props.imgGroup[active].map((v, index) => (
                                <img src={v} key={index}></img>
                            ))}
                        </TabPane>
                    );
                })}
            </Tabs>
        </div>
    );
}
